import { transport } from 'config/transport';

export function callApiSaveThuCongDoan(congDoanId, month, year, body) {
    return transport.post(`/congdoan/${congDoanId}/thuchi/thucongdoan`, body, { params: { month, year } });
}
